import { useEventCallback } from '@cian/react-utils';
import { RefObject, useMemo, useState } from 'react';
import { ISaveSearchModal } from '../types';
import { CianMFUIElement } from '@cian/mf-registry/browser/internal/cianMFUI';

export const useSaveSearchMicrofrontendApi = (microfrontendRef: RefObject<CianMFUIElement | null>) => {
  const [isMicrofrontendApiReady, setIsMicrofrontendApiReady] = useState(false);

  const setMicrofrontendApiReady = useEventCallback(() => {
    setIsMicrofrontendApiReady(true);
  });

  const openSaveSearchModal = useEventCallback(() => {
    const api = (microfrontendRef.current?.instance?.customElement as ISaveSearchModal)?.api;

    /* istanbul ignore next */
    if (api) {
      api['/v1/open-modal']();
    }
  });

  return useMemo(
    () => ({
      isMicrofrontendApiReady,
      setMicrofrontendApiReady,
      openSaveSearchModal,
    }),
    [isMicrofrontendApiReady, openSaveSearchModal, setMicrofrontendApiReady],
  );
};
